/* eslint-disable react/no-unescaped-entities */
import { PercentIcon } from "lucide-react";
import { useIntl } from "react-intl";

import MyProfitAd from "components/advertisements/MyProfitAd";
import RemessaOnlineDiscountAdvertisement from "components/advertisements/RemessaOnlineDiscountAdvertisement";
import NavbarLayout from "components/layouts/NavbarLayout";
import PageHeading from "components/page/PageHeading";
import FundamenteiMetadata from "components/seo/FundamenteiMetadata";

export default function CouponsPage() {
  const intl = useIntl();
  return (
    <NavbarLayout>
      <FundamenteiMetadata
        title={intl.formatMessage({ defaultMessage: "Cupons de Desconto | Fundamentei", id: "CXajt+" })}
        description="Todos os cupons de desconto disponíveis em parceria com o Fundamentei. Aproveite!"
      />
      <div className="mx-auto max-w-7xl px-4 pb-8 xl:px-0">
        <PageHeading
          title="Cupons de Desconto"
          description="Todos os cupons de desconto disponíveis em parceria com o Fundamentei. Aproveite!"
          icon={<PercentIcon className="h-6 w-6 fill-transparent" />}
          iconContainerClassName="border-yellow-200 bg-yellow-50 text-yellow-400"
        />

        <div className="flex flex-col gap-y-12">
          <MyProfitAd />
          <RemessaOnlineDiscountAdvertisement />
        </div>
      </div>
    </NavbarLayout>
  );
}
